import styled, { css } from 'styled-components';

export const Container = styled.div<{ $indentLevel?: number }>`
  display: flex;
  align-items: center;
  width: 100%;

  ${({ $indentLevel, theme }) =>
    !!$indentLevel &&
    css`
      // Cancel the tree list's per-level left shift so the goal row keeps its
      // full width (the right columns then stay aligned across depths); the
      // depth is re-applied inside the goal card's title column instead. Must
      // match the tree list's indentationWidth (2.5) passed by the goal
      // grouping lists.
      margin-left: calc(-1 * ${$indentLevel} * ${theme.spacing(2.5)});
      width: calc(100% + ${$indentLevel} * ${theme.spacing(2.5)});
    `};
`;

export const CardWrapper = styled.div`
  flex: 1;
  min-width: 0;
`;
